import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import CustomTypo from '../../components/CustomTypo';
import Button from '../../components/ButtonCustom';
import DrawerCustom from '../../components/DrawerCustom';
import { TextFieldComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import { EyeIcon, EyeSlashIcon } from '../../components/icons';

const useStyles = makeStyles((theme) => ({
    form: {
        marginTop: theme.spacing(4),
        // backgroundColor: theme.palette.background.box,
        padding: theme.spacing(8, 4, 8, 4),
        borderRadius: theme.spacing(4),
    },
    button: {
        marginTop: theme.spacing(8)
    },
    marginTop: {
        marginTop: theme.spacing(4)
    },
    form2: {
        padding: theme.spacing(4),
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
    },
    btn_save: {
        marginTop: theme.spacing(8),
    },
}));

export default function ChangeMWPasswordView(props) {
    const { t } = useTranslation();
    const classes = useStyles();

    const [showPassword, setShowPassword] = useState({
        old_password: false,
        new_password: false,
        confirm_password: false,
    });

    const { onSubmit } = props;

    const onChangeShowPass = (target, value) => {
        setShowPassword({
            ...showPassword,
            [target]: value,
        })
    }

    return (
        <>
            <DrawerCustom
                open={props.open}
                onClose={() => props.onClose()}
                title={t('change_mw_password')}
                children={
                    <Grid item xs={12}>
                        <Form
                            onSubmit={onSubmit}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item justify='center' className={classes.form}>
                                    <Grid xs={12} item container>
                                        <Field
                                            name="old_password"
                                            component={TextFieldComponent}
                                            label={t('old_password')}
                                            placeholder={t('')}
                                            isEdit={true}
                                            color='default'
                                            type={showPassword && showPassword.old_password ? 'text' : 'password'}
                                            validate={validators.composeValidators(validators.required)}
                                            endAdornment={<Grid item onClick={() => onChangeShowPass('old_password', !showPassword.old_password)} className={classes.cursor}>
                                                {showPassword.old_password ? <EyeIcon /> : <EyeSlashIcon />}
                                            </Grid>}
                                        />
                                        <Field
                                            name="new_password"
                                            component={TextFieldComponent}
                                            label={t('new_password')}
                                            placeholder={t('')}
                                            isEdit={true}
                                            color='default'
                                            type={showPassword && showPassword.new_password ? 'text' : 'password'}
                                            validate={validators.composeValidators(validators.required)}
                                            endAdornment={<Grid item onClick={() => onChangeShowPass('new_password', !showPassword.new_password)} className={classes.cursor}>
                                                {showPassword.new_password ? <EyeIcon /> : <EyeSlashIcon />}
                                            </Grid>}
                                        />
                                        <Field
                                            name="confirm_password"
                                            component={TextFieldComponent}
                                            label={t('confirm_new_password')}
                                            defaultValue={''}
                                            isEdit={true}
                                            color='default'
                                            type={showPassword.confirm_password ? 'text' : 'password'}
                                            autoFocus={true}
                                            validate={validators.composeValidators(validators.required)}
                                            endAdornment={<Grid item onClick={() => onChangeShowPass('confirm_password', !showPassword.confirm_password)} className={classes.cursor}>
                                                {showPassword.confirm_password ? <EyeIcon /> : <EyeSlashIcon />}
                                            </Grid>}
                                        />
                                    </Grid>
                                    <Grid xs={6} item container justify='center' className={classes.btn_save}>
                                        <Button color='onPrimary' fullWidth onClick={() => props.onClose()} id="mw_password_btn_cancel">{t('btn_cancel')}</Button>
                                    </Grid>
                                    <Grid xs={6} item container justify='center' className={classes.btn_save}>
                                        <Button color='primary' fullWidth onClick={handleSubmit} id="mw_password_btn_save">{t('btn_save')}</Button>
                                    </Grid>
                                </Grid>
                            )} />
                    </Grid>
                }
            />
        </>
    );
}
